import React, { useState, FormEvent } from 'react'
import Cookies from 'js-cookie'
import { useSignIn } from '../api/unauth'
import { Link, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useAuth } from '../store'
import { theme } from '../styles/theme'
import { jwtDecode } from 'jwt-decode'
import { useModalApiError } from '../hook'
import { ErrorMessage } from '../components/Form'

type ResponseData = {
  accessToken: string
  refreshToken: string
}

function SignIn() {
  const navigate = useNavigate()
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [ErrorMsg, setErrorMsg] = useState<string[]>([])
  const setAuth = useAuth((store) => store.setAuth)
  const { mutate: signin } = useSignIn({
    onSuccess: (data: ResponseData) => {
      Cookies.set('RT', data.refreshToken)
      const { role, username, sub } = jwtDecode<{ role: string; username:string, sub:string }>(data.accessToken);
      setAuth({role: role, username: username, Id: sub, ...data })
      const newPath = role === 'ROLE_USER' ? '/history' : role === 'ROLE_INIT' ? 'upload' : '/user'
      navigate(newPath)
      // 변수명도 정리필요
    },
    onError: (error: Error) => {
      useModalApiError(error,setErrorMsg)
      console.error('onError > ', error)
    }
  })

  const handleSubmit = async (e: FormEvent) => {
    try {
      e.preventDefault()
      signin({ loginId: email, password })
    } catch (e: any) {
      console.error(`handleSubmit > `, e)
    }
  }

  return (
    <StyledPage_SignIn>
      <div className="wrapper">
        <header>
          <img src={`/logo-icon.png`} alt="TS교통안전공단 로고" />
        </header>

        <form onSubmit={handleSubmit}>
          <input id="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="아이디" required />
          <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="비밀번호" required />
          {ErrorMsg.length > 0 && <div>{ErrorMsg.map((msg, index) => (<ErrorMessage key={index}>{msg}</ErrorMessage>))}</div>}
          <button className="submitter">로그인</button>
        </form>

        {/* <footer>
          <Link to="/unauth/signup">회원가입</Link>
        </footer> */}
      </div>
    </StyledPage_SignIn>
  )
}

export default SignIn

const StyledPage_SignIn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: min-content;
  padding: 20px;
  min-height: 100vh;
  background-color: ${theme.colors.bluebg};

  & > .wrapper {
    display: grid;
    flex: 1;
    gap: 20px;
    max-width: 400px;

    & > header {
      display: flex;
      justify-content: center;
      align-items: center;v
      & > h1 {
        font-size: 36px;
        font-weight: 700;
        color: ${theme.colors.green};
        text-align: center;
      }
      & > img { 
        height: 200px;
      }
    }
    & > form {
      display: grid;
      gap: 20px;
      border: 1px solid ${theme.colors.graybd};
      padding: 20px;
      border-radius: 8px;
      background-color: ${theme.colors.white};

      & > input {
        padding: 0 10px;
        height: 50px;
        border: 1px solid ${theme.colors.graybd};
        border-radius: 8px;
      }
      & > .submitter {
        background-color: ${theme.colors.green};
        color: white;
        font-size: 18px;
        font-weight: 700;
        height: 50px;
        border-radius: 8px;
      }
    }
    & > footer {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;
      color: gray;
    }
  }
`
